export const colors = {
    blackish: "#111111",
    white: "#ffffff",
    blackish_10: "rgba(17, 17, 17, 0.1)",
    blackish_20: "rgba(17, 17, 17, 0.2)",
    blackish_30: "rgba(17, 17, 17, 0.3)",
    blackish_40: "rgba(17, 17, 17, 0.4)",
    blackish_50: "rgba(17, 17, 17, 0.5)",
    blackish_60: "rgba(17, 17, 17, 0.6)",
    blackish_70: "rgba(17, 17, 17, 0.7)",
    blackish_80: "rgba(17, 17, 17, 0.8)",
    blackish_90: "rgba(17, 17, 17, 0.9)",
    white_10: "rgba(255, 255, 255, 0.1)",
    white_20: "rgba(255, 255, 255, 0.2)",
    white_30: "rgba(255, 255, 255, 0.3)",
    white_40: "rgba(255, 255, 255, 0.4)",
    white_50: "rgba(255, 255, 255, 0.5)",
    white_60: "rgba(255, 255, 255, 0.6)",
    white_70: "rgba(255, 255, 255, 0.7)",
    white_80: "rgba(255, 255, 255, 0.8)",
    white_90: "rgba(255, 255, 255, 0.9)",
    graph_red: "rgba(207, 43, 43, 1)",
    graph_green: "rgba(38, 149, 50, 1)",
    graph_blue: "rgba(22, 115, 254, 1)"
};
